import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0d9bb442")

_pushScopeId("data-v-0d9bb442")
const _hoisted_1 = { class: "InvoiceDocumentCheckbox" }
const _hoisted_2 = {
  key: 0,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "8px",
  height: "8px",
  viewBox: "0 0 78.369 78.369",
  "xml:space": "preserve"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("g", null, [
  /*#__PURE__*/_createVNode("path", { d: "M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704\n                    c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704\n                    C78.477,17.894,78.477,18.586,78.049,19.015z" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.checked)
      ? (_openBlock(), _createBlock("svg", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ]))
})